const Products = (state = { Products: [], tvProducts: [], fixeProducts: [], mobileProducts: [], searchMobileProducts: []}, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return {
        ...state,
        products: action.products,
      }
      case 'SET_TV_PRODUCTS':
      return {
        ...state,
        tvProducts: action.products,
      }
      case 'SET_FIXE_PRODUCTS':
      return {
        ...state,
        fixeProducts: action.products,
      }
      case 'SET_MOBILE_PRODUCTS':
      return {
        ...state,
        mobileProducts: action.products,
      }
      case 'SET_MOBILE_PRODUCTS_FOR_SEARCH':
      return {
        ...state,
        searchMobileProducts: action.products,
      }
      case 'SET_INTERNET_PRODUCTS':
      return {
        ...state,
        internetProducts: action.products,
      }
      case 'SET_BUNDLES_PRODUCTS':
      return {
        ...state,
        bundlesProducts: action.products,
      }
    default:
      return state;
  }
};

export default Products;



// WEBPACK FOOTER //
// ./src/reducers/ProductsReducer.js